import { render } from "./searchDialog.vue?vue&type=template&id=a56aee96"
import script from "./searchDialog.vue?vue&type=script&lang=js"
export * from "./searchDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__